import { connect } from 'react-redux';

import Roles from './Roles';
import {
  toggleDeleteModal,
  toggleDrawer,
  setDrawerTitle,
  setRole,
  setRoleList,
  setIsLoading,
  setTabMacros,
  setCustomPermissions,
} from './redux/actions';

const mapStateToProps = (state) => {
  return {
    licenses: state['__global/licenses'],
    drawerOpen: state.rolesPermissions.drawerOpen,
    notification: state.rolesPermissions.notification,
    isLoading: state.rolesPermissions.isLoading,
    tabsMacros: state.rolesPermissions.tabsMacros,
    customPermissions: state.rolesPermissions.customPermissions,
    deleteModalOpen: state.rolesPermissions.deleteModalOpen,
  };
};

const mapStateToDispatch = {
  toggleDeleteModal,
  toggleDrawer,
  setDrawerTitle,
  setRole,
  setRoleList,
  setIsLoading,
  setTabMacros,
  setCustomPermissions,
};

export default connect(mapStateToProps, mapStateToDispatch)(Roles);
